import { render } from "./YouTubeConsentPlaceholder.vue?vue&type=template&id=344a9908&scoped=true"
import script from "./YouTubeConsentPlaceholder.vue?vue&type=script&lang=js"
export * from "./YouTubeConsentPlaceholder.vue?vue&type=script&lang=js"

import "./YouTubeConsentPlaceholder.vue?vue&type=style&index=0&id=344a9908&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-344a9908"]])

export default __exports__